import styled from 'styled-components';
import { Collapse } from 'antd';
import color from 'theme/colors';

export const PackagesHistoryStyled = styled(Collapse)`
  margin: 2rem 0;
  background-color: transparent;

  .ant-collapse-header {
    font-weight: 600;
  }

  .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
    color: ${color.primary};
    font-weight: 600;
    font-size: 0.85rem;
    line-height: 1;
  }

  .ant-collapse-content-box {
    padding: 0;
  }

  .ant-pagination {
    padding-right: 1rem;
  }

  .ant-table-footer {
    background-color: transparent;
    padding: 0;
    .table-footer-tools {
      padding: 1rem;
      display: flex;
      justify-content: end;
      align-items: center;
    }
  }
`;
